import React from "react";

import { Router, useNavigate } from "@reach/router";

import ProductList from "./ProductList";
import ProductSave from "./ProductSave";

import styles from "./Product.module.less";

function Product({ brand }) {
  const navigate = useNavigate();

  return (
    <div className={styles.Product}>
      <Router>
        <ProductList path="/" brand={brand} />
        <ProductSave path="save" brand={brand} />
      </Router>
    </div>
  );
}

export default Product;
